/**
 * Shrnutí zápisu nákupních cen do ceníků, které vrací schválení dokladu
 * (`cenik` v odpovědi /schvalit i /hromadna-akce). Vrací větu do hlášky,
 * nebo null, když se ceníku nic netýkalo (doklad bez skladových položek).
 */
export function cenikShrnuti(cenik) {
    if (!cenik) return null;

    const casti = [];
    if (cenik.zapsano) casti.push(`${cenik.zapsano}× nová cena`);
    if (cenik.aktualizovano) casti.push(`${cenik.aktualizovano}× přepsaná cena`);
    if (cenik.preskoceno) casti.push(`${cenik.preskoceno}× nezapsáno`);

    return casti.length ? casti.join(', ') : null;
}
